import { BubbleMenu } from "@tiptap/react"
import { Edit, HighlightOff } from "@mui/icons-material";
import { notImage } from "../helper";
import { useState } from "react";
const ImageMenu = ({ editor, editImage }) => {
  const [img, setImg] = useState();
  return (
    <div>
      <BubbleMenu
        editor={editor}
        tippyOptions={{
          duration: 100,
          //placement: "bottom", // Choose 'top', 'bottom', 'left', or 'right'
          strategy: "absolute", // Use fixed positioning
          offset: [0, 20], // Adjust the offset as needed
        }}
        shouldShow={({ editor, state }) => {
          const { $from } = state.selection;
          const node = $from.nodeAfter ?? $from.nodeBefore;

          const isImage = node && !notImage(node);
          if (isImage) {
            setImg(node.attrs.src);
          } else {
            setImg(null);
          }
          return isImage;
        }}
      >
        <div className=" text-sm overflow-hidden flex  bg-neutral-500 text-white rounded-md ">
          <button
            className="p-2 hover:bg-neutral-600 flex items-center gap-4"
            onClick={() => {
              editor.commands.setTextSelection(0);
              editImage(img);
            }}
          >
            <Edit />
          </button>
          <button
            className="p-2 hover:bg-neutral-600 flex items-center gap-4"
            onClick={() => editor.commands.deleteSelection()}
          >
            <HighlightOff />
          </button>
         
        </div>
      </BubbleMenu>
    </div>
  );
};

export default ImageMenu;
